import type { StatComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const statDuplicate: DuplicationHandler<StatComponentSpec> = (spec) => {
  spec.queryId = crypto.randomUUID();
};
